import React from 'react'
import { Box, Container } from '@mui/material'
// import NextImage from 'next/image'
import { EmtTypography } from 'emt-components-v2'
// import VariantImages from '@/assets/VariantImages'
// import NavNextLink from '@/components/EMT/NavNextLink'

type Props = {
  title: React.ReactNode
  link?: string
}

export default function PublicPetSittingNav({ title, link }: Props) {
  return (
    <Box
      sx={{
        height: '68px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'purple.600',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
        }}
        maxWidth="lg"
      >
        {/* {link ? (
          <NavNextLink sx={{ color: '#fff', cursor: 'pointer' }} href={link}>
            <NextImage width={100} src={VariantImages.PetSitter} alt="petsitter" style={{ alignSelf: 'center' }} />
          </NavNextLink>
        ) : (
          <NextImage width={100} src={VariantImages.PetSitter} alt="petsitter" style={{ alignSelf: 'center' }} />
        )} */}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <EmtTypography variant="body2" fontWeight="bold" color="#762D8A">
            {title}
          </EmtTypography>
        </Box>
      </Container>
    </Box>
  )
}
